import { Pipe, PipeTransform } from '@angular/core';

import { IconName } from '@recruitee/user-interface';

@Pipe({
  name: 'rtCreditCardVendorIcon',
  pure: true,
  standalone: true,
})
export class CreditCardIconPipe implements PipeTransform {
  public static readonly availableCardIcons: IconName[] = [
    'amex',
    'dinners',
    'discover',
    'mastercard',
    'visa',
  ];

  public transform(value: string, fallback: 'credit-card'): IconName {
    return (
      (value && CreditCardIconPipe.availableCardIcons.find(name => name === value.toLowerCase())) ||
      fallback
    );
  }
}
